<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2XgZQy/tc-custom/9781488090615.jpg?1728155917521" alt="This image is the cover for the book Soldier's Redemption, Redemption Ranch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soldier's Redemption, Redemption Ranch
      </h1>
      <p class="bookDescription body article font2">
        <b><i>Enjoy this sweet romance from bestselling author Lee Tobin McClain, part of the Redemption Ranch seriesA single mom and her sweet son could lead to one man’s second chance at family…<br/><br/>Blaming himself for the accident that claimed his wife and son, ranch manager Finn Gallagher vows he’ll never remarry. Yet he’s drawn to his new rescue-dog caretaker, Kayla White, and her little boy. But the single mother’s running from something in her past. And as he begins wishing the little family could be his, Finn must convince her to trust him with her secret.<br/><br/><i>From Love Inspired: Uplifting stories of faith, forgiveness, and hope. <br/><br/></i><b>Experience more heartwarming romances with the rest of the Redemption Ranch series:<br/><br/></b><i>A Soldier’s Return<br/><br/>The Twins’ Family Christmas<br/><br/>The Nanny’s Secret Baby</i></i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Tobin McClain
      </h2>
      
      <p class="authorDescription body article">Lee Tobin McClain is the <I>New York Times</I> bestselling author of more than thirty novels. A professor-turned-writer, she finds inspiration in her beautiful and brilliant daughter, her goofy goldendoodle, and her aptly named cat, Trouble. Learn more about her books at www.leetobinmcclain.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ce03b580